(function () {
    'use strict';

    angular
        .module('homeDashboardControllers')
        .controller('DashboardAricController', Controller);

    Controller.$inject = ['$scope', 'commonAricService', 'grcGovernanceProcessService'];

    function Controller($scope, commonAricService, grcGovernanceProcessService) {

        // Get ARIC Active Process
        grcGovernanceProcessService
            .getActiveARIC()
            .then(function (govProcess) {

                var isGovProcDisabled = !_.isObject(govProcess) || _.isUndefined(govProcess.GovernanceProcessID);
                if (isGovProcDisabled) return;

                $scope.governanceProcess = govProcess;
                
                // Get Owners and Status
                commonAricService
                    .getControlOwnersAndStatus()
                    .then(function (statusOwners) {
                        $scope.statusOwners = statusOwners;
                    });
            });

        // Get Status
        $scope.getStatusCount = function (status) {
            return _.filter($scope.statusOwners, { ControlOwnerStatusValue: status }).length;
        };

        // Get Completion percentage
        $scope.getCompletionPercentage = function (status) {
            if (_.isUndefined($scope.statusOwners)) { return; }

            var completedCount = _.filter($scope.statusOwners, { ControlOwnerStatusValue: 'Completed' }).length;
            var totalCount = $scope.statusOwners.length;
            var perct = (completedCount / totalCount) * 100;

            return perct;
        };
    }
})();